export default "__VITE_ASSET__CfN$0ZpK__"